import React from 'react';

import { Link } from 'libs/router';

import SystemMessage from './SystemMessage';
import MediaPreview from 'components/MediaPreview';

import { DELIVERABLE_TYPE_INSTAGRAM_POST } from 'utils/deliverables';

import type { DeliverablesFilterCampaign } from 'types';

type Props = {
  metadata: {
    postType: DeliverablesFilterCampaign,
    post: string
  },
  text: string
};

type State = {
  previewUrl: string
}

class SystemChatMessagePostAdded extends SystemMessage<Props> {
  state: State = {
    previewUrl: ''
  };

  hasInstagramPostPreview() {
    const {
      metadata
    } = this.props;

    return metadata.postType && metadata.postType === DELIVERABLE_TYPE_INSTAGRAM_POST;
  }

  render() {
    const {
      metadata,
      text
    } = this.props;

    return (
      <React.Fragment>
        {this.renderIcon()}
        <div className="messages-system-message__container">
          <div
            className="messages-system-message__bubble"
            data-qa="messages-system-message-post-added__bubble"
          >
            {text}
            {
              metadata.post &&
                <div>
                  <Link
                    to={`${metadata.post}`}
                    className="messages-system-message__link messages-system-message__link--post"
                    target="_blank"
                  >
                    {metadata.post}
                  </Link>
                </div>
            }
            {
              this.hasInstagramPostPreview() &&
                <div>
                  <MediaPreview
                    className="system-chat-message__media"
                    attachment={{
                      id: 'system-message-post-added',
                      url: metadata.post,
                      externalUrl: metadata.post,
                      format: 'image'
                    }}
                    width={200}
                    height={200}
                  />
                </div>
            }
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessagePostAdded;
